<template>
  <div>
    <v-simple-table>
      <template v-slot:default>
        <thead>
          <tr>
            <th style="text-align: center"> {{ $t("Fecha compra") }} </th>
            <th style="text-align: center"> {{ $t("Bono") }} </th>
            <th style="text-align: center"> {{ $t("Cliente") }} </th>
            <th style="text-align: center"> {{ $t("Teléfono fijo") }} </th>
            <th style="text-align: center"> {{ $t("Teléfono móvil") }} </th>
            <th style="text-align: center"> {{ $t("Email") }} </th>
            <th style="text-align: center"> {{ $t("Ver sesiones") }} </th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(current, index) in bonos" :key="index"  >
            <td style="text-align: center"> {{ current.fecha | moment('L')}} </td>
            <td style="text-align: center"> {{ current.nombre }} </td>
            <td style="text-align: center"> {{ current.cliente }} </td>
            <td style="text-align: center"> {{ current.fijo }} </td>
            <td style="text-align: center"> {{ current.movil }} </td>
            <td style="text-align: center"> {{ current.email }} </td>
            <td style="text-align: center">
              <v-btn fab small icon color="primary" @click="open_dialog_sesiones(current.id)" :title="$t('Ver sesiones')">
                <v-icon>mdi-eye</v-icon>
              </v-btn>
            </td>
          </tr>
        </tbody>
      </template>
    </v-simple-table>

    <DialogSesiones
        v-if="dialog_sesiones"
        v-model="dialog_sesiones"
        :item="current_bono_vendido"
    />
  </div>
</template>

<script>
export default {
  name: 'ResumenEstadisticaClientesBonosPendientes',

  props:{
    filters: {
      type: Object,
      required: true
    }
  },

  data: () => ({
    bonos: [],
    current_bono_vendido: null,
    dialog_sesiones: false,
  }),

  methods: {
    async get_clientes_bonos_pendientes_resumen(){
      try {
        const bonos = await this.$store.dispatch('estadisticas/get_bonos_pendientes', {
          centros: this.filters['centros'],
          fecha_inicio: this.filters['dates'][0],
          fecha_fin: this.filters['dates'][1]
        })
        this.bonos = bonos.results
      } catch (err) {
	      this.$snotify.error(
		      this.$t("Ha ocurrido un error"),
		      this.$t('Atención {0}', [this.$store.getters['auth/user'].first_name])
	      )
      }
    },
    async open_dialog_sesiones(bono_vendido) {
      this.current_bono_vendido = {"id": bono_vendido}
      this.dialog_sesiones = true
    },
  },

  computed: {
    centro(){
      return this.$store.state.centro.centro
    }

  },

  components: {
    DialogSesiones: () => import('@/views/Clientes/Components/DialogSesiones'),
  }
}
</script>
